import React from 'react';
import Link from 'next/link';
import { SecondaryCtaLinkProps } from './types';
import { buttonBase, buttonSizes, buttonVariants } from '../Button/buttonStyles';
import { addTrailingSlashToInternalUrl } from '@/lib/utils/trailingSlash';

const SECONDARY_CTA_STYLES = {
  default: `${buttonBase} ${buttonSizes.default} ${buttonVariants.secondary}`,
  hero: `${buttonBase} ${buttonSizes.default} ${buttonVariants.heroSecondary}`,
} as const;

export const SecondaryCtaLink: React.FC<SecondaryCtaLinkProps> = ({
  buttonText,
  linkUrl,
  target = '_self',
  relAttribute,
  className = '',
  children,
  variant = 'default',
}) => {
  const normalizedLinkUrl = addTrailingSlashToInternalUrl(linkUrl);
  return (
    <Link
      href={normalizedLinkUrl}
      target={target}
      rel={relAttribute}
      className={`${SECONDARY_CTA_STYLES[variant]} ${className}`.trim()}
    >
      {children || buttonText}
    </Link>
  );
};

export default SecondaryCtaLink;
